module.exports = __webpack_public_path__ + "img/Tigray_Certificate.c7bbf56c.jpg";